import { supabase, getSessionId } from './supabaseClient';
import 'flatpickr/dist/flatpickr.min.css';
import flatpickr from "flatpickr";
import weekSelectPlugin from "flatpickr/dist/plugins/weekSelect/weekSelect.js";

document.addEventListener('DOMContentLoaded', async () => {
    const welcomeSidebar = document.getElementById('welcome-sidebar');
    const collapseButton = document.getElementById('collapse-button');
    const lightCandleButton = document.getElementById('light-candle-button');
    const candleModal = document.getElementById('candle-creation-modal');
    const chapelContainer = document.getElementById('chapel-container');
    const submitButton = document.getElementById('submit-candle');
    const lightYourCandleButton = document.getElementById('light-your-candle-button');
    const editCandlesButton = document.getElementById('edit-candles');
    const donationButton = document.getElementById('donation-button');
    const cancelCandleButton = document.getElementById('cancel-candle');
    const videoContainer = document.getElementById('video-container');
    const doneEditingButton = document.getElementById('done-editing-button');
    const sanctuaryLampModal = document.getElementById('sanctuary-lamp-modal');
    const sanctuaryLampForm = document.getElementById('sanctuary-lamp-form');
    const thankYouMessage = document.getElementById('thank-you-message');
    const sanctuaryLampFormContent = document.getElementById('sanctuary-lamp-form-content');
    const formErrorMessage = document.getElementById('form-error-message');
    const sendPrayerCardButton = document.getElementById('send-prayer-card-button');
    const prayerCardModal = document.getElementById('prayer-card-modal');
    const prayerCardForm = document.getElementById('prayer-card-form');
    const closePrayerCard = document.getElementById('close-prayer-card');
    const prayerCardSuccess = document.getElementById('prayer-card-success');
    const prayerCardLoginPrompt = document.getElementById('prayer-card-login-prompt');
    const prayerCardLoginBtn = document.getElementById('prayer-card-login-btn');

    let returnToPrayerCardAfterLogin = false;

    const showLoginModalBtn = document.getElementById('show-login-modal-btn');
    const loggedInStatus = document.getElementById('logged-in-status');
    const loginModal = document.getElementById('login-modal');
    const loginForm = document.getElementById('login-form');
    const closeLoginModal = document.getElementById('close-login-modal');
    const loginError = document.getElementById('login-error');

    const deliveryMethodContainer = document.getElementById('delivery-method-container');
    const deliveryRadios = document.getElementsByName('deliveryMethod');
    const customEmailInputContainer = document.getElementById('custom-email-input');
    const customEmailInput = document.querySelector('input[name="recipientEmail"]');
    const communityMemberSelectContainer = document.getElementById('community-member-select');
    const communityMemberSelect = document.querySelector('select[name="recipientId"]');

    // Slide in the welcome message on page load
    setTimeout(() => {
        welcomeSidebar.classList.add('open');
    }, 500); // Delay for effect

    async function checkAuthAndSetup() {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
            if (showLoginModalBtn) showLoginModalBtn.classList.add('hidden');
            if (loggedInStatus) loggedInStatus.classList.remove('hidden');
            if (deliveryMethodContainer) deliveryMethodContainer.classList.remove('hidden');
            if (prayerCardLoginPrompt) prayerCardLoginPrompt.classList.add('hidden');
            
            // Fetch community members
            const { data: profiles, error } = await supabase.from('profiles').select('id, full_name').order('full_name');
            if (!error && profiles && communityMemberSelect) {
                communityMemberSelect.innerHTML = '<option value="">Select a member...</option>';
                profiles.forEach(profile => {
                    const option = document.createElement('option');
                    option.value = profile.id;
                    option.textContent = profile.full_name || 'Unknown Member';
                    communityMemberSelect.appendChild(option);
                });
            }
        } else {
            if (prayerCardLoginPrompt) prayerCardLoginPrompt.classList.remove('hidden');
        }
    }

    checkAuthAndSetup();

    if (showLoginModalBtn) {
        showLoginModalBtn.addEventListener('click', () => {
            returnToPrayerCardAfterLogin = false;
            if (loginModal) loginModal.classList.remove('hidden');
        });
    }

    if (prayerCardLoginBtn) {
        prayerCardLoginBtn.addEventListener('click', () => {
            returnToPrayerCardAfterLogin = true;
            if (prayerCardModal) prayerCardModal.classList.add('hidden');
            if (loginModal) loginModal.classList.remove('hidden');
        });
    }

    if (closeLoginModal) {
        closeLoginModal.addEventListener('click', () => {
            if (loginModal) loginModal.classList.add('hidden');
        });
    }

    if (loginForm) {
        loginForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const email = loginForm.email.value;
            const password = loginForm.password.value;
            const submitBtn = e.submitter || loginForm.querySelector('button[type="submit"]');
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Logging in...';
            }
            if (loginError) loginError.classList.add('hidden');
            
            const { error } = await supabase.auth.signInWithPassword({ email, password });
            
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Log In';
            }

            if (error) {
                if (loginError) {
                    loginError.textContent = error.message;
                    loginError.classList.remove('hidden');
                }
            } else {
                loginForm.reset();
                if (loginModal) loginModal.classList.add('hidden');
                await checkAuthAndSetup();
                
                // Return to prayer card if that's where they came from
                if (returnToPrayerCardAfterLogin && prayerCardModal) {
                    prayerCardModal.classList.remove('hidden');
                    returnToPrayerCardAfterLogin = false; // Reset for next time
                }
            }
        });
    }
    
    // Delivery Method Toggle
    deliveryRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            if (e.target.value === 'custom') {
                if (customEmailInputContainer) customEmailInputContainer.classList.remove('hidden');
                if (customEmailInput) customEmailInput.required = true;
                if (communityMemberSelectContainer) communityMemberSelectContainer.classList.add('hidden');
                if (communityMemberSelect) communityMemberSelect.required = false;
            } else {
                if (customEmailInputContainer) customEmailInputContainer.classList.add('hidden');
                if (customEmailInput) customEmailInput.required = false;
                if (communityMemberSelectContainer) communityMemberSelectContainer.classList.remove('hidden');
                if (communityMemberSelect) communityMemberSelect.required = true;
            }
        });
    });

    collapseButton.addEventListener('click', () => {
        welcomeSidebar.classList.toggle('open');
        if (welcomeSidebar.classList.contains('open')) {
            collapseButton.innerHTML = '&raquo;'; // Change arrow direction
        } else {
            collapseButton.innerHTML = '&laquo;'; // Change arrow direction
        }
    });

    videoContainer.addEventListener('mousedown', (e) => {
        if (!isEditing) return; // Only allow drag in edit mode

        e.preventDefault();
        // Use the existing drag logic by setting up the activeDrag object
        activeDrag = {
            candleFrame: videoContainer, // Re-using property name from candle drag logic
            offsetX: e.clientX - videoContainer.offsetLeft,
            offsetY: e.clientY - videoContainer.offsetTop,
        };
        videoContainer.style.zIndex = 1000; // Ensure it's on top while dragging
        videoContainer.style.cursor = 'grabbing';
    });
    
    videoContainer.addEventListener('touchstart', (e) => {
        if (!isEditing) return; // Only allow drag in edit mode

        // The global touchmove listener will handle the drag, so we just set up state here.
        const touch = e.touches[0];
        activeDrag = {
            candleFrame: videoContainer,
            offsetX: touch.clientX - videoContainer.offsetLeft,
            offsetY: touch.clientY - videoContainer.offsetTop,
        };
        videoContainer.style.zIndex = 1000;
        videoContainer.style.cursor = 'grabbing';
    }, { passive: false });

    let isEditing = false;
    let candleOptions = [];
    let iconOptions = [];
    let igniteHintElement = null;
    let doneEditingHintElement = null;

    async function loadAssets() {
        // Directly define the assets instead of listing them
        const candleData = [{ name: 'candle2.png' }, { name: 'whitecandle_1.png' }, { name: 'greencandle1.png' }, { name: 'purplecandle1.png' }, { name: 'redcandle1.png' }];
        const iconData = [
            { name: 'icon_butterfly.png' },
            { name: 'icon_cat.png' },
            { name: 'icon_cross.png' },
            { name: 'icon_crossheart.png' },
            { name: 'icon_dog.png' },
            { name: 'icon_feathers1.png' },
            { name: 'icon_healing.png' },
            { name: 'icon_pray.png' },
            { name: 'icon_wings.png' },
            { name: 'icon_dove.png' }
        ];

        candleOptions = candleData.map(file => {
            const id = file.name.split('.')[0];
            const candlePublicUrlResponse = supabase.storage.from('assets').getPublicUrl(`candles/${file.name}`);
            const url = candlePublicUrlResponse?.data?.publicUrl;
            let videoUrl;
            if (file.name === 'whitecandle_1.png') {
                const videoPublicUrlResponse = supabase.storage.from('assets').getPublicUrl('videos/whitecandle1.webm');
                videoUrl = videoPublicUrlResponse?.data?.publicUrl;
            } else if (file.name === 'candle2.png') {
                const videoPublicUrlResponse = supabase.storage.from('assets').getPublicUrl('videos/candle2_1.webm');
                videoUrl = videoPublicUrlResponse?.data?.publicUrl;
            } else if (file.name === 'greencandle1.png') {
                const videoPublicUrlResponse = supabase.storage.from('assets').getPublicUrl('videos/greencandle1.webm');
                videoUrl = videoPublicUrlResponse?.data?.publicUrl;
            } else if (file.name === 'purplecandle1.png') {
                const videoPublicUrlResponse = supabase.storage.from('assets').getPublicUrl('videos/purplecandle1.webm');
                videoUrl = videoPublicUrlResponse?.data?.publicUrl;
            } else if (file.name === 'redcandle1.png') {
                const videoPublicUrlResponse = supabase.storage.from('assets').getPublicUrl('videos/redcandle1.webm');
                videoUrl = videoPublicUrlResponse?.data?.publicUrl;
            } else {
                const videoPath = `videos/${file.name.replace(/\.[^/.]+$/, "")}.mp4`;
                const videoPublicUrlResponse = supabase.storage.from('assets').getPublicUrl(videoPath);
                videoUrl = videoPublicUrlResponse?.data?.publicUrl;
            }
            return { id, url, videoUrl };
        });

        iconOptions = iconData.map(file => {
            const iconPublicUrlResponse = supabase.storage.from('assets').getPublicUrl(`icons/${file.name}`);
            const url = iconPublicUrlResponse?.data?.publicUrl;
            return {
                id: file.name.split('.')[0],
                url,
            };
        });

        populateChoices();
    }

    function populateChoices() {
        const candleSelectionContainer = document.getElementById('candle-selection-container');
        candleSelectionContainer.innerHTML = '';
        candleOptions.forEach(candle => {
            const card = document.createElement('div');
            card.className = 'candle-card';
            card.dataset.candleId = candle.id;

            const img = document.createElement('img');
            img.src = candle.url;
            img.alt = `Candle ${candle.id}`;
            card.appendChild(img);
            candleSelectionContainer.appendChild(card);
        });

        const iconSelectionContainer = document.getElementById('icon-selection-container');
        iconSelectionContainer.innerHTML = '';
        iconOptions.forEach(icon => {
            const item = document.createElement('div');
            item.className = 'icon-item';
            item.dataset.iconId = icon.id;

            const img = document.createElement('img');
            img.src = icon.url;
            img.alt = `Icon ${icon.id}`;
            item.appendChild(img);
            iconSelectionContainer.appendChild(item);
        });
        const lampSelectionContainer = document.getElementById('lamp-selection-container');
        if (lampSelectionContainer) {
            lampSelectionContainer.innerHTML = '';
            const lampCard = document.createElement('div');
            lampCard.className = 'lamp-image-container'; // Use a specific class to avoid generic card styling
            lampCard.dataset.itemId = 'sanctuary-lamp';

            const lampImg = document.createElement('img');
            lampImg.src = 'https://kyefbzlavvgodczasyod.supabase.co/storage/v1/object/public/assets/lamp/alight_lamp.webp';
            lampImg.alt = 'Sanctuary Lamp';
            lampCard.appendChild(lampImg);

            const dedicateButton = document.createElement('button');
            dedicateButton.textContent = 'Dedicate this lamp';
            dedicateButton.className = 'dedicate-lamp-button text-white px-4 py-2 rounded-full w-48 mt-2';
            dedicateButton.style.backgroundColor = '#d161ae';
            dedicateButton.addEventListener('click', () => {
                // Reset form state before showing the modal
                if (sanctuaryLampForm) {
                    sanctuaryLampForm.reset();
                }
                if (sanctuaryLampFormContent && thankYouMessage) {
                    sanctuaryLampFormContent.classList.remove('hidden');
                    thankYouMessage.classList.add('hidden');
                }

                // Reset accordion to be all closed
                const accordionItems = document.querySelectorAll('#sanctuary-lamp-form .accordion-item');
                accordionItems.forEach(item => {
                    item.classList.remove('active');
                });

                candleModal.classList.add('hidden');
                sanctuaryLampModal.classList.remove('hidden');
                initializeCalendar();
            });

            const lampWrapper = document.createElement('div');
            lampWrapper.className = 'flex flex-col items-center'; // This will center the button under the card
            lampWrapper.appendChild(lampCard);
            lampWrapper.appendChild(dedicateButton);

            lampSelectionContainer.appendChild(lampWrapper);
        }
    }

    await loadAssets();
    await loadAndDisplayCandles();
    await fetchAndDisplayDedication();
    subscribeToCandleChanges();

    async function fetchAndDisplayDedication() {
        const today = new Date();
        // Format today as YYYY-MM-DD
        const todayStr = today.toISOString().split('T')[0];

        const { data, error } = await supabase
            .from('sanctuary_dedications')
            .select('dedication_message')
            .eq('is_approved', true)
            .lte('start_date', todayStr)
            .gte('end_date', todayStr);

        if (error) {
            console.error('Error fetching sanctuary dedication:', error);
            return;
        }

        if (data && data.length > 0) {
            const dedicationContainer = document.getElementById('sanctuary-dedication-container');
            const dedicationMessage = document.getElementById('sanctuary-dedication-message');
            if (dedicationContainer && dedicationMessage) {
                dedicationMessage.innerHTML = data.map(d => d.dedication_message).join('<br><br>');
                dedicationContainer.classList.remove('hidden');
            }
        }
    }

    let selectedCandle = null;
    let selectedIcon = null;
    let selectedLamp = null;

    lightCandleButton.addEventListener('click', () => {
        hideIgniteHint();
        hideDoneEditingHint();
        candleModal.classList.toggle('hidden');
        if (isEditing) {
            toggleEditMode();
        }
    });

    cancelCandleButton.addEventListener('click', () => {
       candleModal.classList.add('hidden');
       submitButton.classList.remove('halo-effect');
       selectedCandle = null;
       selectedIcon = null;
       selectedLamp = null;
       document.querySelectorAll('.candle-card, .icon-item').forEach(el => el.classList.remove('selected-item'));
    });

    candleModal.addEventListener('click', (e) => {
        // If the user clicks on the modal background (the overlay), close the modal.
        if (e.target === candleModal) {
            candleModal.classList.add('hidden');
            submitButton.classList.remove('halo-effect');
            selectedCandle = null;
            selectedIcon = null;
            selectedLamp = null;
            document.querySelectorAll('.candle-card, .icon-item').forEach(el => el.classList.remove('selected-item'));
        }
    });

    if (sanctuaryLampModal) {
        sanctuaryLampModal.addEventListener('click', (e) => {
            if (e.target === sanctuaryLampModal) {
                sanctuaryLampModal.classList.add('hidden');
            }
        });
    }

    const candleSelectionContainer = document.getElementById('candle-selection-container');
    candleSelectionContainer.addEventListener('click', (event) => {
        const card = event.target.closest('.candle-card');
        if (card && card.dataset.candleId) {
            // Deselect lamp if it was selected
            const lampCard = document.querySelector('#lamp-selection-container .selected-item');
            if (lampCard) {
                lampCard.classList.remove('selected-item');
                selectedLamp = null;
            }

            Array.from(candleSelectionContainer.children).forEach(child => {
                child.classList.remove('selected-item');
            });
            card.classList.add('selected-item');
            selectedCandle = card.dataset.candleId;
            submitButton.classList.add('halo-effect');
        }
    });

    const iconSelectionContainer = document.getElementById('icon-selection-container');
    iconSelectionContainer.addEventListener('click', (event) => {
        const item = event.target.closest('.icon-item');
        if (item && item.dataset.iconId) {
            // Deselect lamp if it was selected
            const lampCard = document.querySelector('#lamp-selection-container .selected-item');
            if (lampCard) {
                lampCard.classList.remove('selected-item');
                selectedLamp = null;
            }
            
            Array.from(iconSelectionContainer.children).forEach(child => {
                child.classList.remove('selected-item');
            });
            item.classList.add('selected-item');
            selectedIcon = item.dataset.iconId;
        }
    });

    submitButton.addEventListener('click', () => {
        hideIgniteHint();
        hideDoneEditingHint();
        if (!selectedCandle) {
            alert('Please select a candle.');
            return;
        }

        candleModal.classList.add('hidden');
        submitButton.classList.remove('halo-effect');

        if (selectedCandle) {
            createDraggableCandle(selectedCandle, selectedIcon);
            lightYourCandleButton.classList.remove('hidden');
        }

        // If we were in edit mode, exit it now.
        if (isEditing) {
            toggleEditMode();
        }

        selectedCandle = null;
        selectedIcon = null;
        selectedLamp = null;
        document.querySelectorAll('.candle-card, .icon-item').forEach(el => el.classList.remove('selected-item'));
    });

    let activeDrag = null;
    document.addEventListener('mousemove', handleDrag, { passive: false });
    document.addEventListener('touchmove', handleDrag, { passive: false });
    document.addEventListener('mouseup', stopDragging);
    document.addEventListener('touchend', stopDragging);

 
     lightYourCandleButton.addEventListener('click', () => {
        hideIgniteHint();
         const candleFrame = document.querySelector('.draggable-candle-frame.selected');
         if (candleFrame) {
             lightCandle(candleFrame);
         }
     });

    function startDrag(e) {
        // This function is now generic and handles dragging for any candle
        e.preventDefault();
        const candleFrame = e.currentTarget;

        // A candle cannot be dragged if it's lit, unless we are in edit mode and it's the user's candle.
        if (candleFrame.isLit) {
            if (!isEditing || (candleFrame.dataset.dbId && candleFrame.dataset.sessionId !== getSessionId())) {
                return;
            }
        }

        document.querySelectorAll('.draggable-candle-frame').forEach(frame => {
            frame.classList.remove('selected');
        });
        candleFrame.classList.add('selected');

        const event = e.touches ? e.touches[0] : e;
        activeDrag = {
            candleFrame,
            offsetX: event.clientX - candleFrame.offsetLeft,
            offsetY: event.clientY - candleFrame.offsetTop,
        };
        candleFrame.style.zIndex = 1000;
        candleFrame.style.cursor = 'grabbing';
    }

    function createDraggableCandle(candleId, iconId) {
        const candleFrame = document.createElement('div');
        candleFrame.className = 'draggable-candle-frame absolute selected';
        candleFrame.dataset.candleId = candleId;

        // --- Start of new positioning logic ---
        const unlitCandles = document.querySelectorAll('.draggable-candle-frame:not(.lit)');
        const offset = unlitCandles.length * 160; // 160px offset for each new candle
        const chapelWidth = chapelContainer.clientWidth;
        
        // Start placing from the left, but not right at the edge
        let startPosition = 100;
        
        // If the line of candles gets too long, wrap it to the next 'row'
        let horizontalPosition = startPosition + offset;
        let verticalPosition = chapelContainer.clientHeight - 200; // 200px from the bottom

        // Check if the next candle would go off-screen and wrap if necessary
        if (horizontalPosition + 100 > chapelWidth) {
            const candlesPerRow = Math.floor((chapelWidth - startPosition) / 160);
            const rowIndex = Math.floor(unlitCandles.length / candlesPerRow);
            const colIndex = unlitCandles.length % candlesPerRow;
            
            horizontalPosition = startPosition + colIndex * 160;
            verticalPosition = chapelContainer.clientHeight - 200 - (rowIndex * 150); // Stack rows upwards
        }

        candleFrame.style.left = `${horizontalPosition}px`;
        candleFrame.style.top = `${verticalPosition}px`;
        // --- End of new positioning logic ---

        candleFrame.style.cursor = 'move';

        const candleData = candleOptions.find(c => c.id === candleId);
        const candleImage = document.createElement('img');
        candleImage.src = candleData.url;
        candleImage.className = 'w-52 h-52 object-cover';
        candleFrame.appendChild(candleImage);

        // Prevent default browser image drag behavior
        candleImage.addEventListener('dragstart', (e) => e.preventDefault());

        if (iconId) {
            candleFrame.dataset.iconId = iconId; // Save for later
            const iconData = iconOptions.find(i => i.id === iconId);
            const iconImage = document.createElement('img');
            iconImage.src = iconData.url;
            iconImage.className = 'w-10 h-10 absolute bottom-6 right-8';
            candleFrame.appendChild(iconImage);
        }

        chapelContainer.appendChild(candleFrame);

        // Attach the generic drag handler
        candleFrame.addEventListener('mousedown', startDrag);
        candleFrame.addEventListener('touchstart', startDrag, { passive: false });

        showMoveHint(candleFrame);
    }

    function showMoveHint(candleElement) {
        const hint = document.createElement('div');
        hint.textContent = 'Drag to move!';
        hint.className = 'move-hint';
        document.body.appendChild(hint);

        const rect = candleElement.getBoundingClientRect();
        
        const hintTop = rect.top + 10;
        const hintLeft = rect.left + (rect.width / 2) - (hint.offsetWidth / 2);

        hint.style.left = `${hintLeft}px`;
        hint.style.top = `${hintTop}px`;
        hint.style.transform = 'translateX(-50%)';

        setTimeout(() => {
            hint.style.opacity = '0';
            setTimeout(() => {
                if (hint.parentNode) {
                    hint.parentNode.removeChild(hint);
                }
            }, 500);
        }, 3000);
    }

    function hideIgniteHint() {
        if (igniteHintElement && igniteHintElement.parentNode) {
            clearTimeout(igniteHintElement.timer);
            igniteHintElement.parentNode.removeChild(igniteHintElement);
            igniteHintElement = null;
        }
    }

    function showIgniteHint() {
        // If a hint is already showing, remove it before creating a new one.
        hideIgniteHint();

        igniteHintElement = document.createElement('div');
        igniteHintElement.textContent = 'Now, ignite your candle!';
        igniteHintElement.className = 'ignite-hint';
        
        // Insert the hint before the ignite button in the DOM
        lightYourCandleButton.parentNode.insertBefore(igniteHintElement, lightYourCandleButton);

        igniteHintElement.style.opacity = '1';

        igniteHintElement.timer = setTimeout(() => {
            igniteHintElement.style.opacity = '0';
            setTimeout(() => {
                hideIgniteHint();
            }, 500); // Remove from DOM after fade out
        }, 4000); // 4 seconds
    }

    function hideDoneEditingHint() {
        if (doneEditingHintElement && doneEditingHintElement.parentNode) {
            clearTimeout(doneEditingHintElement.timer);
            doneEditingHintElement.parentNode.removeChild(doneEditingHintElement);
            doneEditingHintElement = null;
        }
    }

    function showDoneEditingHint() {
        hideDoneEditingHint();
        doneEditingHintElement = document.createElement('div');
        doneEditingHintElement.textContent = 'Click "Done Editing" to save.';
        doneEditingHintElement.className = 'done-editing-hint';
        
        doneEditingButton.parentNode.insertBefore(doneEditingHintElement, doneEditingButton);
        doneEditingHintElement.style.opacity = '1';
        doneEditingHintElement.timer = setTimeout(() => {
            doneEditingHintElement.style.opacity = '0';
            setTimeout(() => {
                hideDoneEditingHint();
            }, 500); // Remove from DOM after fade out
        }, 4000); // 4 seconds
    }

    function handleDrag(e) {
        if (!activeDrag) return;
        e.preventDefault();
        const event = e.touches ? e.touches[0] : e;
        const { candleFrame, offsetX, offsetY } = activeDrag;
        const x = Math.min(Math.max(0, event.clientX - offsetX), chapelContainer.clientWidth - candleFrame.offsetWidth);
        const y = Math.min(Math.max(0, event.clientY - offsetY), chapelContainer.clientHeight - candleFrame.offsetHeight);
        candleFrame.style.left = `${x}px`;
        candleFrame.style.top = `${y}px`;
    }

    function stopDragging() {
        if (!activeDrag) return;

        const draggedItem = activeDrag.candleFrame;
        draggedItem.style.zIndex = 'auto';
        draggedItem.style.cursor = 'move';
        
        // Show hint only when a candle is dropped, not the video bowl
        if (draggedItem.classList.contains('draggable-candle-frame')) {
            if (!isEditing) {
                showIgniteHint();
            } else {
                showDoneEditingHint();
            }
        }

        activeDrag = null;
    }

   async function lightCandle(candleFrame) {
       if (candleFrame.isLit) return;
 
       // If we light a candle while in edit mode, exit edit mode.
       if (isEditing) {
           toggleEditMode();
       }
 
       const candleImage = candleFrame.querySelector('img:not([class*="icon"])');
       const candleId = candleFrame.dataset.candleId;
       const candleData = candleOptions.find(c => c.id === candleId);
       if (candleImage) {
           // Set the size of the frame before removing the image
           const rect = candleImage.getBoundingClientRect();
           candleFrame.style.width = `${rect.width}px`;
           candleFrame.style.height = `${rect.height}px`;
           candleImage.remove();
       }
  
       const video = document.createElement('video');
       video.className = 'w-full h-full object-cover';
       video.autoplay = true;
       video.loop = true;
       video.muted = true;
       video.playsInline = true;

       const source = document.createElement('source');
       source.src = candleData.videoUrl;
       const videoExtension = candleData.videoUrl.split('.').pop().split('?')[0];
       source.type = `video/${videoExtension}`;
       
       video.appendChild(source);
       candleFrame.appendChild(video);
 
       candleFrame.style.cursor = 'default';
       candleFrame.isLit = true;
       candleFrame.classList.add('lit');
 
        // Insert into Supabase
        try {
            const newCandleData = {
                candle_id: candleId,
                icon_id: candleFrame.dataset.iconId || null,
                position_x: (parseFloat(candleFrame.style.left) / chapelContainer.clientWidth) * 100,
                position_y: (parseFloat(candleFrame.style.top) / chapelContainer.clientHeight) * 100,
                session_id: getSessionId(),
                device_type: 'desktop',
            };

            const { data, error } = await supabase.from('candles').insert([newCandleData]).select();
 
            if (error) {
                throw error;
            }

            if(data && data.length > 0) {
                candleFrame.dataset.dbId = data[0].id;
                if (data[0].session_id) {
                    candleFrame.dataset.sessionId = data[0].session_id;
                }
            }

        } catch (error) {
            console.error('Error saving candle to database:', error);
            // Notify user here if desired, e.g., using a toast notification
        }
 
       setTimeout(() => {
           candleFrame.remove();
       }, 30 * 60 * 1000); // 30 minutes
 
       lightYourCandleButton.classList.add('hidden');
       sendPrayerCardButton.classList.remove('hidden');
   }

   function toggleEditMode() {
       isEditing = !isEditing;
       const allUserCandles = document.querySelectorAll('.draggable-candle-frame');
 
       if (isEditing) {
            candleModal.classList.add('hidden');
            doneEditingButton.classList.remove('hidden');
            showDoneEditingHint();
            videoContainer.style.cursor = 'move';

            allUserCandles.forEach(candle => {
               // Only allow editing if the candle belongs to the current session
               if (!candle.dataset.dbId || candle.dataset.sessionId === getSessionId()) {
                   candle.style.cursor = 'move'; // All candles are draggable in edit mode
                   candle.addEventListener('contextmenu', showDeleteMenu);
               }
           });
       } else {
            doneEditingButton.classList.add('hidden');
            hideDoneEditingHint();
            videoContainer.style.cursor = 'default';

            allUserCandles.forEach(candle => {
               // If lit, cursor is default. If not, it's 'move'.
               candle.style.cursor = candle.isLit ? 'default' : 'move';
               candle.removeEventListener('contextmenu', showDeleteMenu);
           });
       }
   }

   function renderLitCandle(candle) {
       const candleFrame = document.createElement('div');
       candleFrame.className = 'draggable-candle-frame absolute'; // Ensure 'absolute' for positioning
       candleFrame.dataset.candleId = candle.candle_id;
       candleFrame.dataset.dbId = candle.id; // Store Supabase ID
       if (candle.session_id) {
           candleFrame.dataset.sessionId = candle.session_id;
       }
       const left = (candle.position_x / 100) * chapelContainer.clientWidth;
       const top = (candle.position_y / 100) * chapelContainer.clientHeight;
       candleFrame.style.left = `${left}px`;
       candleFrame.style.top = `${top}px`;
       candleFrame.style.cursor = 'default';

       const candleData = candleOptions.find(c => c.id === candle.candle_id);
       if (!candleData) {
           console.error('Could not find data for candle_id:', candle.candle_id);
           return;
       }

       // Create and play the video for the lit candle
       const video = document.createElement('video');
       video.className = 'w-52 h-52 object-cover'; // Match size of original candle image
       video.autoplay = true;
       video.loop = true;
       video.muted = true;
       video.playsInline = true;

       const source = document.createElement('source');
       source.src = candleData.videoUrl;
       const videoExtension = candleData.videoUrl.split('.').pop().split('?')[0];
       source.type = `video/${videoExtension}`;
       video.appendChild(source);
       candleFrame.appendChild(video);

       // Add icon if it exists
       if (candle.icon_id) {
            candleFrame.dataset.iconId = candle.icon_id;
           const iconData = iconOptions.find(i => i.id === candle.icon_id);
           if (iconData) {
               const iconImage = document.createElement('img');
               iconImage.src = iconData.url;
               iconImage.className = 'w-10 h-10 absolute bottom-6 right-8';
               candleFrame.appendChild(iconImage);
           }
       }
       
       // Attach drag handlers so it can be moved in edit mode
       candleFrame.addEventListener('mousedown', startDrag);
       candleFrame.addEventListener('touchstart', startDrag, { passive: false });

       chapelContainer.appendChild(candleFrame);

       // Set it as "lit" to prevent dragging unless in edit mode
       candleFrame.isLit = true;
       candleFrame.classList.add('lit');

       // Automatically remove the candle after 30 minutes from when it was created
       const timeElapsed = Date.now() - new Date(candle.created_at).getTime();
       const timeRemaining = (30 * 60 * 1000) - timeElapsed;

       if (timeRemaining > 0) {
           setTimeout(() => {
               candleFrame.remove();
           }, timeRemaining);
       } else {
           // If it's already expired, remove it immediately
           candleFrame.remove();
       }
   }

    async function loadAndDisplayCandles() {
        const thirtyMinutesAgo = new Date(Date.now() - 30 * 60 * 1000).toISOString();
        const { data: candles, error } = await supabase.from('candles')
            .select('*')
            .gte('created_at', thirtyMinutesAgo)
            .or('device_type.eq.desktop,device_type.is.null'); // Fallback for old candles
   
        if (error) {
            console.error('Error loading candles:', error);
            return;
        }
   
        candles.forEach(candle => {
            renderLitCandle(candle);
        });
    }

    function subscribeToCandleChanges() {
        supabase.channel('candles')
            .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'candles' }, (payload) => {
                console.log('REALTIME: INSERT received', payload.new);
                if (payload.new.device_type === 'mobile') return; // Ignore mobile candles
                // Check if a candle with this unique database ID already exists.
                const existingCandle = document.querySelector(`[data-db-id="${payload.new.id}"]`);
                if (!existingCandle) {
                   renderLitCandle(payload.new);
                }
            })
            .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'candles' }, (payload) => {
                console.log('REALTIME: UPDATE received', payload.new);
                if (payload.new.device_type === 'mobile') return;
                const candleFrame = document.querySelector(`[data-db-id="${payload.new.id}"]`);
                if (candleFrame) {
                   const left = (payload.new.position_x / 100) * chapelContainer.clientWidth;
                   const top = (payload.new.position_y / 100) * chapelContainer.clientHeight;
                   candleFrame.style.left = `${left}px`;
                   candleFrame.style.top = `${top}px`;
                }
            })
            .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'candles' }, (payload) => {
                console.log('REALTIME: DELETE received', payload.old);
                const candleFrame = document.querySelector(`[data-db-id="${payload.old.id}"]`);
                if (candleFrame) {
                    candleFrame.remove();
                }
            })
            .subscribe((status) => {
                console.log('REALTIME: Subscription status:', status);
                if (status === 'SUBSCRIBED') {
                    console.log('Successfully subscribed to real-time candle updates!');
                }
            });
   }
 
    editCandlesButton.addEventListener('click', () => {
        if (!isEditing) {
            toggleEditMode();
        }
    });

   doneEditingButton.addEventListener('click', async () => {
       if (isEditing) {
           const candlesToUpdate = [];
           document.querySelectorAll('.draggable-candle-frame').forEach(candleFrame => {
               if (candleFrame.dataset.dbId && candleFrame.dataset.sessionId === getSessionId()) { // Only update candles that exist in the DB and belong to user
                   candlesToUpdate.push({
                       id: candleFrame.dataset.dbId,
                       position_x: (parseFloat(candleFrame.style.left) / chapelContainer.clientWidth) * 100,
                       position_y: (parseFloat(candleFrame.style.top) / chapelContainer.clientHeight) * 100,
                       session_id: getSessionId(), // Include session_id for RLS
                   });
               }
           });

           if (candlesToUpdate.length > 0) {
               const { error } = await supabase.from('candles').upsert(candlesToUpdate);
               if (error) {
                   console.error('Error updating candle positions:', error);
               }
           }
           
           toggleEditMode(); // Exit edit mode
       }
   });

   if (sendPrayerCardButton) {
       sendPrayerCardButton.addEventListener('click', () => {
           prayerCardModal.classList.remove('hidden');
           prayerCardSuccess.classList.add('hidden');
           prayerCardForm.classList.remove('hidden');
           prayerCardForm.reset();
       });
   }

   if (closePrayerCard) {
       closePrayerCard.addEventListener('click', () => {
           prayerCardModal.classList.add('hidden');
       });
   }

   if (prayerCardModal) {
       prayerCardModal.addEventListener('click', (e) => {
           if (e.target === prayerCardModal) {
               prayerCardModal.classList.add('hidden');
           }
       });
   }

   if (prayerCardForm) {
       prayerCardForm.addEventListener('submit', async (e) => {
           e.preventDefault();
           
           const formData = new FormData(prayerCardForm);
           
           // Check honeypot
           if (formData.get('bot_check')) {
               console.log('Bot detected');
               return;
           }

           const senderName = formData.get('senderName');
           const userMessage = formData.get('userMessage');
           const deliveryMethod = formData.get('deliveryMethod') || 'custom';
           let recipientEmail = formData.get('recipientEmail');
           let recipientId = formData.get('recipientId');

           if (deliveryMethod === 'custom') {
               recipientId = null;
           } else {
               recipientEmail = null;
           }
           
           const submitButton = prayerCardForm.querySelector('button[type="submit"]');
           if (submitButton) {
               submitButton.disabled = true;
               submitButton.textContent = 'Sending...';
           }

           try {
               const { error } = await supabase.functions.invoke('send-prayer-card', { 
                   body: { 
                       recipientEmail,
                       recipientId,
                       senderName,
                       userMessage, 
                       imageUrl: 'https://kyefbzlavvgodczasyod.supabase.co/storage/v1/object/public/assets/prayer-card/prayer-card-image.png' 
                   } 
               });

               if (error) throw error;
               
               prayerCardForm.classList.add('hidden');
               prayerCardSuccess.classList.remove('hidden');
               
               setTimeout(() => {
                   prayerCardModal.classList.add('hidden');
                   sendPrayerCardButton.classList.add('hidden');
               }, 3000);

           } catch (error) {
               console.error('Error sending prayer card:', error);
               alert('There was an error sending the prayer card. Please try again.');
           } finally {
               if (submitButton) {
                   submitButton.disabled = false;
                   submitButton.textContent = 'Send Card';
               }
           }
       });
   }

   function initializeCalendar() {
       const minDate = new Date().fp_incr(14);
       // Adjust minDate to the next Sunday to ensure full weeks are selectable
       if (minDate.getDay() !== 0) {
           minDate.setDate(minDate.getDate() + (7 - minDate.getDay()));
       }

       flatpickr("#calendar-container", {
           minDate: minDate,
           plugins: [weekSelectPlugin()],
           dateFormat: "Y-m-d",
           altInput: true,
           altFormat: "\\W\\e\\e\\k \\o\\f F j, Y",
           "locale": {
               "firstDayOfWeek": 0 // start week on Sunday
           },
           onChange: function(selectedDates, dateStr, instance) {
               if (selectedDates.length > 0) {
                   const date = selectedDates[0];
                   // Find the Sunday of the selected week
                   const weekStart = new Date(date);
                   weekStart.setDate(date.getDate() - date.getDay());
                   
                   // Format as Y-m-d
                   const year = weekStart.getFullYear();
                   const month = String(weekStart.getMonth() + 1).padStart(2, '0');
                   const day = String(weekStart.getDate()).padStart(2, '0');
                   const formattedDate = `${year}-${month}-${day}`;
                   
                   // Update the selected date in flatpickr to be the Sunday
                   if (dateStr !== formattedDate) {
                       instance.setDate(formattedDate, false);
                   }
               }
           }
       });
   }

        if (sanctuaryLampForm) {
        sanctuaryLampForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            if (!sanctuaryLampForm.checkValidity()) {
                formErrorMessage.classList.remove('hidden');
                formErrorMessage.scrollIntoView({ behavior: 'smooth', block: 'start' });
                return;
            }
            formErrorMessage.classList.add('hidden');

            const submitButton = e.submitter || sanctuaryLampForm.querySelector('button[type="submit"]') || sanctuaryLampForm.querySelector('button:last-of-type');
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = 'Submitting...';
            }

            const formData = new FormData(sanctuaryLampForm);
            const data = Object.fromEntries(formData.entries());

            // Check honeypot
            if (data.bot_check) {
                console.log('Bot detected');
                sanctuaryLampFormContent.classList.add('hidden');
                thankYouMessage.classList.remove('hidden');
                return;
            }

            try {
                const { data: responseData, error } = await supabase.functions.invoke('sanctuary-request', {
                    body: { data }
                });

                if (error) {
                    console.error("Edge Function returned an error:", error);
                    throw error;
                }

                sanctuaryLampFormContent.classList.add('hidden');
                thankYouMessage.classList.remove('hidden');

            } catch (error) {
                console.error('Error submitting form caught in catch block:', error);
                alert('There was an issue submitting your request. Please try again.');
            } finally {
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.textContent = 'Submit to Ministry Team';
                }
            }
        });
    } 


    document.querySelectorAll('.accordion-title').forEach(title => {
        title.addEventListener('click', () => {
            const accordionItem = title.parentElement;
            if (accordionItem.classList.contains('active')) {
                accordionItem.classList.remove('active');
            } else {
                document.querySelectorAll('.accordion-item').forEach(item => item.classList.remove('active'));
                accordionItem.classList.add('active');
                if (accordionItem.querySelector('#calendar-container')) {
                    initializeCalendar();
                }
            }
        });
    });

    document.querySelectorAll('.next-btn').forEach(button => {
        button.addEventListener('click', () => {
            const currentItem = button.closest('.accordion-item');
            const nextItem = currentItem.nextElementSibling;
            currentItem.classList.remove('active');
            if (nextItem) {
                nextItem.classList.add('active');
                if (nextItem.querySelector('#calendar-container')) {
                    initializeCalendar();
                }
            }
        });
    });

    const increaseDonation = document.getElementById('increase-donation');
    const decreaseDonation = document.getElementById('decrease-donation');
    const donatedAmount = document.getElementById('donated-amount');

    increaseDonation.addEventListener('click', () => {
        donatedAmount.value = parseInt(donatedAmount.value) + 1;
    });

    decreaseDonation.addEventListener('click', () => {
        const currentValue = parseInt(donatedAmount.value);
        if (currentValue > 20) {
            donatedAmount.value = currentValue - 1;
        }
    });

   function showDeleteMenu(e) {
       e.preventDefault();
       const candleFrame = e.currentTarget;

       const menu = document.createElement('div');
       menu.className = 'absolute bg-white border rounded shadow-lg';
       menu.style.left = `${e.clientX}px`;
       menu.style.top = `${e.clientY}px`;
       menu.innerHTML = '<button class="block w-full text-left px-4 py-2 hover:bg-gray-100">Delete</button>';

       document.body.appendChild(menu);

       const deleteButton = menu.querySelector('button');
       deleteButton.addEventListener('click', async () => {
           const dbId = candleFrame.dataset.dbId;
           if (dbId) {
               if (candleFrame.dataset.sessionId !== getSessionId()) {
                   console.error("Cannot delete someone else's candle");
                   menu.remove();
                   return;
               }
               const { error } = await supabase.from('candles').delete().match({ id: dbId, session_id: getSessionId() });
               if (error) {
                   console.error('Error deleting candle:', error);
               } else {
                   // The real-time subscription will handle removal from other clients' UI
                   candleFrame.remove(); // Remove from current user's UI immediately on success
               }
           } else {
               // If it's a candle that hasn't been lit yet, just remove it locally.
               candleFrame.remove();
           }
           menu.remove();
       });

       document.addEventListener('click', () => menu.remove(), { once: true });
   }
});
